import React, { useState } from "react";

import { GeneralTable, DashboardLayout } from "components";

import "assets/scss/billingPortal/modules/recursiveBillingSetup/billingUploadInvalidMessages.scss";
import { func_validation } from "functions";



export default function BillingUploadInvalidMessages(props) {
    // Get messages from local storage
    let storage = window.localStorage;
    let messages = storage.getItem("billingSetup_invalidExcelFileMsg");
    let msgType = storage.getItem("billingSetup_invalidExcelFileType");

    let headerTitle = (msgType == "error")? "Error": "Warning";

    // Store messages in object.
    let rawData = messages.split("\n");
    let rawDataObj = {};
    rawData.map((rawMsg, idx) => {
        // Get row number
        let rowNumStringArray = rawMsg.match(/^Row [0-9]*:/g);
        if (func_validation.isArrayNotEmpty(rowNumStringArray)) {
            let rowNum = rowNumStringArray[0].substring(4, rowNumStringArray[0].length - 1);

            // Get message
            let msgStartPos = rawMsg.indexOf(":") + 2;
            let msg = rawMsg.substring(msgStartPos);
    
            if (func_validation.isObjectEmpty(rawDataObj) ||
                (func_validation.isObjectNotEmpty(rawDataObj) && 
                func_validation.isNullUndefined(rawDataObj[rowNum]))) {
                
                rawDataObj[rowNum] = [];
                rawDataObj[rowNum].push(msg);
            }
            else {
                let existingMsgArray = rawDataObj[rowNum];
                existingMsgArray.push(msg);
            }
        }
    });

    // Sort the messages
    let rowNumbers = [];
    for (const key in rawDataObj) {
        let rowNum = parseInt(key);
        if (func_validation.isNumberValid(rowNum)) {
            rowNumbers.push(rowNum);
        }
    }
    rowNumbers.sort(function(a, b){
        return a - b;
    });

    // Store sorted messages
    let tableData = [];
    rowNumbers.map((rowNum, idx) => {
        let obj = {
            rowNum,
            subRows: [
                {
                    rowNum: [...rawDataObj[rowNum]]
                }
            ]
        }
        tableData.push(obj);
    });

    // Get specified page data
    const { tableData: tableData_formatted, getTableData } = useTableDataSelection(tableData);

    return (
        <DashboardLayout 
            headerTitle={headerTitle + " Found List"}

            bodyClassName={"billingUploadInvalidMessages"}
            body={(
                <GeneralTable
                    className={"billingUploadInvalidMessages-table"}

                    getTableData={getTableData}

                    outerTableHeader={() => { 
                        return (
                            <div className={"billingUploadInvalidMessages-table-outerHeader"}>List</div>
                        ) 
                    }}

                    isHeaderHidden

                    columns={[
                        {
                            id: "rowNumber",
                            accessor: "rowNum",
                            bodyCellClassName: "billingUploadInvalidMessages-table-cell",
                            Cell: (props) => {
                                let cell = func_validation.getObjectPropertyValue(props, "cell");
                                let value = func_validation.getObjectPropertyValue(cell, "value");

                                let row = func_validation.getObjectPropertyValue(props, "row");
                                let depth = func_validation.getObjectPropertyValue(row, "depth");
                                let isSubrow = (depth > 0);

                                // Subrow
                                if (isSubrow &&
                                    func_validation.isArrayNotEmpty(value)) {

                                    let msgArray = value;
                                    let subRowOutput = msgArray.map((msg, idx) => {
                                        return (<div key={idx} className={"billingUploadInvalidMessages-table-cell-subrow noWrap-text-ellipsis"}>{"- " + msg}</div>)
                                    });

                                    return subRowOutput;
                                }
                                // Row
                                else if (func_validation.isNumberValid(value)) {
                                    let rowNum = value;
                                    return (<div className={"billingUploadInvalidMessages-table-cell-row noWrap-text-ellipsis"}>{"Row " + rowNum}</div>);
                                }
                                else {
                                    return "";
                                }
                            },
                        }
                    ]}
                    data={tableData_formatted}

                    isExpanderRequired

                    isUsingPagination
                    totalRecords={tableData.length}

                    isColumnResizeable 
                    isTableOddRowsDarken 
                />
            )}
        />
    )
}


function useTableDataSelection(tableData) {
    // States
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(tableData.length);

    function getTableData(currentPage, pageSize) {
        setCurrentPage(currentPage);
        setPageSize(pageSize);
    }

    let startPos = currentPage * pageSize;
    let endPos = startPos + pageSize;
    let tableData_new = tableData.slice(startPos, endPos);

    return {
        tableData: tableData_new,
        getTableData
    };
}